import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { StorageService } from './services/storage.service';
import { SessionService } from './services/session.service';
import { PipesModule } from './pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { LangInterceptorService, RequestInterceptorService } from './interceptors';
import { SnackBarModule } from './components/snack-bar/snack-bar.module';
import { BreakpointsModule } from './modules/breakpoints/breakpoints.module';
import { SpinnerModule } from './components/spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    PipesModule,
    TranslateModule,
    SnackBarModule,
    BreakpointsModule,
    SpinnerModule
  ],
  exports: [
    TranslateModule,
    SnackBarModule,
    BreakpointsModule,
    PipesModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SessionService, StorageService],
    };
  }
  static forAuthAccess(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LangInterceptorService, multi: true },
      ],
    };
  }
}
